module.exports = __webpack_public_path__ + "static/img/18.f619efb3.jpg";